<template>
  <div style="padding-top: 4rem; padding-bottom: 4rem">
    <p
      align="center"
      style="
        font-family: Arial, Helvetica, sans-serif;
        font-size: 2.5rem;
        font-weight: 800;
        color: #1c3e8e;
      "
    >
      Bienvenidos a nuestra sección de ofertas
    </p>
    <divider-component />
    <div align="center">
      <p
        style="
          width: 50%;
          font-family: Arial, Helvetica, sans-serif;
          font-weight: 400;
        "
        align="center"
      >
        Aqui encontraras un catálogo de productos en oferta y en liquidación.
      </p>
    </div>
  </div>
  <div align="center" v-if="loading">
    <v-progress-circular
      :size="70"
      :width="7"
      color="purple"
      :indeterminate="loading"
    ></v-progress-circular>
  </div>

  <div v-for="(oferta, index) in categorias" :key="index">
    <v-card class="cardCarrusel">
      <v-card-title>
        <h4>
          {{ oferta.descripcion }}
          <span style="color: crimson">Oferta - {{ oferta.descuento }}%</span>
        </h4>
      </v-card-title>
      <div class="d-flex justify-end">
        <v-btn
          variant="tonal"
          color="blue"
          style="margin-right: 50px"
          @click="VerMasProductos(oferta)"
          >Ver todos</v-btn
        >
      </div>
      <v-card-text>
        <carrusel-ofertas-component :Oferta="oferta" />
      </v-card-text>
    </v-card>
  </div>

  <div v-if="categorias.length <= 0">
    <v-card style="margin: 30px">
      <h4 align="center">Por el momento no hay ofertas</h4>
      <v-img alt="" :src="require('@/assets/sin-info.png')" height="100" />
    </v-card>
  </div>
</template>

<script>
import ApiOfertas from '@/Api/ApiOfertas';
import CarruselOfertasComponent from '@/components/CarruselOfertasComponent.vue';
import DividerComponent from '@/components/DividerComponent.vue';

export default {
  components: { CarruselOfertasComponent, DividerComponent },
  data() {
    return {
      categorias: [],
      loading:true
    };
  },
  mounted() {
    this.GetCategorias();
  },
  methods: {
    async GetCategorias() {
      await ApiOfertas.GetAllOfertas()
        .then((response) => {
          this.categorias = response.data;
          this.loading=false;
        })
        .catch((error) => {
          this.loading=false;
        });
    },
    VerMasProductos(Oferta) {
      // Aquí pasas la variable a la ruta de VistaB

      const ofertaJson = JSON.stringify(Oferta);
      this.$router.push({
        name: 'productos-ofertas',
        query: { oferta: ofertaJson },
      });
    },
  },
};
</script>

<style scoped>
@media (min-width: 1000px) {
  /* Ajusta este valor según el breakpoint que desees */
  .cardCarrusel {
    margin: 50px;
  }
}

@media (max-width: 999px) {
  .cardCarrusel {
    margin: 0px;
  }
}
</style>
